import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-zinc-900 border-t border-emerald-900/40" data-id="element-85">
      <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-86">
        <div className="mb-10" data-id="element-87">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-88">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-89" />
        </div>

        <div className="space-y-6 mb-12" data-id="element-90">
          <div className="bg-black/80 p-6 rounded-2xl border border-emerald-900/40 shadow-lg flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-91">
            <div className="text-left" data-id="element-92">
              <h3 className="font-bold text-lg text-white" data-id="element-93">
                🇧🇷 MEGAPACK PORTUGUÉS LISTO
              </h3>
              <p className="text-sm text-emerald-300" data-id="element-94">6 Tomos + 4 Bonus</p>
            </div>
            <div className="flex flex-col items-center sm:items-end shrink-0" data-id="element-95">
              <div className="flex items-center gap-2 mb-2" data-id="element-96">
                <span className="font-black text-xl text-white" data-id="element-97">
                  $19.990 ARS
                </span>
              </div>
              <a href="https://portugueslisto.shop/cart/47729181065410:1" target="_blank" rel="noopener noreferrer" data-id="element-98">
                <Button size="sm" variant="outline" data-id="element-99">
                  🔥 QUIERO MI MEGAPACK
                </Button>
              </a>
            </div>
          </div>

          <div className="bg-black p-6 rounded-2xl border-2 border-emerald-400 shadow-xl flex flex-col sm:flex-row items-center justify-between gap-6 relative overflow-hidden" data-id="element-100">
            <div className="absolute top-0 right-0 bg-emerald-400 text-black text-[10px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-101">
              MÁS ELEGIDO
            </div>
            <div className="text-left" data-id="element-102">
              <h3 className="font-bold text-lg text-white" data-id="element-103">
                ⚡ MEGAPACK + NIVEL PRO
              </h3>
            </div>
            <div className="flex flex-col items-center sm:items-end shrink-0" data-id="element-104">
              <div className="flex items-center gap-2 mb-2" data-id="element-105">
                <span className="font-black text-xl text-white" data-id="element-106">
                  $27.990 ARS
                </span>
              </div>
              <a href="https://portugueslisto.shop/cart/47729196531906:1" target="_blank" rel="noopener noreferrer" data-id="element-107">
                <Button size="sm" variant="primary" data-id="element-108">
                  ⚡ QUIERO EL MEGAPACK + NIVEL PRO
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-200 font-medium" data-id="element-109">
          <div className="flex items-center gap-1.5" data-id="element-110">
            <Lock className="w-4 h-4 text-emerald-300" data-id="element-111" />
            <span data-id="element-112">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-113">
            <Zap className="w-4 h-4 text-emerald-400" data-id="element-114" />
            <span data-id="element-115">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-116">
            <Shield className="w-4 h-4 text-emerald-400" data-id="element-117" />
            <span data-id="element-118">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-119">
            <CreditCard className="w-4 h-4 text-emerald-300" data-id="element-120" />
            <span data-id="element-121">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}